// src/client.tsx
import { initClient } from "rwsdk/client";

// Initialize the base client (required for RSC hydration)
initClient();
